export default __webpack_public_path__ + "static/media/wizard-bg-white-bot.f233e461.svg";